<app-base-template (modal)="openModal(content)"  (dataExportToExcel)="exportToExcel()"(tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [showExportBtn]="showExportBtn" [isExportDisable]="isExportDisable" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Backward Workflow Map with Client</div>

  </div>
  <div class="modal-body custom-size">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <mat-radio-group (change)="onTicketButtonChange($event)">
        <mat-radio-button *ngFor="let button of ttypes;" [value]="button.id" [checked]="button.checked">{{button.name}}</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="form-group">
      <!--<mat-slide-toggle (toggleChange)="slideChange()" [checked]="slideChecked"> <b class="blue">Forward Workflow</b></mat-slide-toggle>-->
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
              (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="workflowSelected"
              (change)="onWorkflowChange($event.target.selectedIndex)">
        <option *ngFor="let workflow of workflows" [value]="workflow.id">{{workflow.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="componentSelected"
              (change)="onComponentsChange($event.target.selectedIndex)">
        <option *ngFor="let component of components" [value]="component.id">{{component.name}}</option>
      </select>
    </div>
    <div>
      <mat-radio-group (change)="onButtonChange($event)" class="font-13">
        <div *ngFor="let button of radiobutton;">
          <mat-radio-button [value]="button.id" [checked]="button.checked">{{button.title}}</mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
    <div [hidden]="ishidden">
      <div class="form-group">
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="supportGroupSelected"
                (change)="onGroupChange($event.target.selectedIndex)">
          <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
        </select>
      </div>
      <div class="form-group">
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="userSelected"
                (change)="onUserChange($event.target.selectedIndex)">
          <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
        </select>
      </div>
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="workflowLevel"
               placeholder="Enter Work Flow Level like Step-1,Step-2...">
      </div>
      <div class="form-group">
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="indicatorSelected"
                (change)="onIndicatorChange($event.target.selectedIndex)">
          <option *ngFor="let indicator of indicators" [value]="indicator.id">{{indicator.name}}</option>
        </select>
      </div>

      <div class="form-group">
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="wClientSelected"
                (change)="onWclientChange($event.target.selectedIndex)">
          <option *ngFor="let wclient of wClients" [value]="wclient.id">{{wclient.name}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<ng-template #content1 let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Backward Workflow</div>

  </div>
  <div class="modal-body custom-size">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <table class="table table-striped">
      <thead>
      <tr>
        <th>Ticket Type</th>
        <th >Category</th>
        <th>Support Group</th>
        <th >User</th>
        <th>Level</th>
        <th >Parent Workflow</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of bWorkflow;">
        <td>{{item.ticket_type}}</td>
        <td>{{item.category}}</td>
        <td>{{item.groupName}}</td>
        <td>{{item.user}}</td>
        <td>{{item.level}}</td>
        <td>{{item.parent}}</td>
      </tr>

      </tbody>
    </table>
  </div>
  <!--<div class="modal-footer pad-8">-->
    <!--<button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>-->
    <!--<button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>-->
  <!--</div>-->
</ng-template>
<notifier-container></notifier-container>
